module.exports = {
  env: 'production',
  authConfig: {},
  logSearchBaseUrl: 'https://gra2.logs.ovh.com/streams/5d15f9ad8671c9000102a032/search',
  logLinkBaseUrl: 'https://gra2.logs.ovh.com/messages/',
  apiUrl: '/'
}
